import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Heading, Input, Button, FormControl, FormLabel, Text, useToast, Spinner, Flex,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { supabase, isSupabaseConfigured } from '../lib/supabaseClient';

const AdminLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!isSupabaseConfigured) {
      setChecking(false);
      return;
    }
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate('/admin', { replace: true });
      else setChecking(false);
    });
  }, [navigate]);

  if (!isSupabaseConfigured) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="surface.muted" px={4}>
        <Box maxW="480px" textAlign="center" bg="surface.base" borderRadius="2xl" p={10} boxShadow="md">
          <Heading as="h1" size="lg" mb={4}>{t('admin.loginTitle')}</Heading>
          <Text color="text.soft">{t('admin.notConfigured')}</Text>
        </Box>
      </Flex>
    );
  }

  if (checking) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="surface.muted">
        <Spinner size="xl" color="brand.500" thickness="4px" />
      </Flex>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      toast({
        title: t('admin.loginError'),
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    navigate('/admin', { replace: true });
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="surface.muted" px={4}>
      <Box w="100%" maxW="420px">
        <Box bg="brand.900" color="white" borderRadius="2xl" boxShadow="lg" p={8} textAlign="center" mb={6}>
          <Heading as="h1" size="lg">
            COOPEC
            <Box as="span" color="accent.400">MICROTOUS</Box>
          </Heading>
          <Text color="whiteAlpha.800" mt={1} fontSize="sm">{t('admin.loginTitle')}</Text>
        </Box>
        <Box bg="surface.base" borderRadius="2xl" boxShadow="md" p={8} border="1px solid" borderColor="border.subtle">
          <form onSubmit={handleSubmit}>
            <FormControl id="admin-email" mb={5} isRequired>
              <FormLabel fontWeight="600">{t('admin.email')}</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@microtous.com"
              />
            </FormControl>
            <FormControl id="admin-password" mb={8} isRequired>
              <FormLabel fontWeight="600">{t('admin.password')}</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>
            <Button
              type="submit"
              size="lg"
              w="100%"
              colorScheme="brand"
              isLoading={loading}
              loadingText={t('admin.signIn')}
            >
              {t('admin.signIn')}
            </Button>
          </form>
        </Box>
      </Box>
    </Flex>
  );
};

export default AdminLogin;
